var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-combobox',{attrs:{"items":_vm.mdi_keys,"label":"svg иконка"},on:{"change":_vm.updateValue},model:{value:(_vm.chosed_svg),callback:function ($$v) {_vm.chosed_svg=$$v},expression:"chosed_svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }